<main class="container-fluid main-page settings questions gx-0">
    <div class="settings-sub-header w-100 px-4 pt-5 pb-4 border-0 bg-white">
        <div class="d-md-flex justify-content-between">
            <h3 class="pt-1">
                {{'api_keys.subtitle' | translate}}
                <small class="d-block text-secondary pt-2 ps-0">
                    {{'api_keys.subtitle_desc_1' | translate}} <a href="https://apidocs.teammood.com" target="_blank">https://apidocs.teammood.com</a>
                </small>
            </h3>
            <div class="d-flex align-items-md-center">
                <button type="button"
                        class="btn btn-primary px-4 mb-1 align-top"
                        data-cy="api-key-new"
                        [disabled]="$safeNavigationMigration(apiKeys?.length) > 0"
                        (click)="addKey()"><i class="far fa-plus"></i> {{'api_keys.new' | translate}}</button>
            </div>
        </div>
    </div>

    <hr class="border-top border-secondary border-1 opacity-25 my-0">
    
    <div class="row filter-table bg-grey pt-5 container-fluid container-fluid-limite api-table">
        <div class="col-md-10 mx-auto">
            <div class="panel panel-default">
                <div class="panel-heading"><i class="far fa-key-skeleton"></i> {{'api_keys.your_keys' | translate}}</div>
                <table class="table table-hover">
                    <thead>
                    <tr>
                        <th scope="col">{{'api_keys.scope' | translate}}</th>
                        <th scope="col">{{'api_keys.creation' | translate}}</th>
                        <th scope="col">{{'api_keys.value' | translate}}</th>
                        <th scope="col">{{'api_keys.copyToClipboard' | translate}}</th>
                        <th scope="col"></th>
                        <th scope="col" class="text-center">{{'api_keys.renew' | translate}}</th>
                        <th scope="col" class="text-center">{{'api_keys.delete' | translate}}</th>
                        <th scope="col"></th>
                    </tr>
                    </thead>
    
                    <tbody>
                    @for(apiKey of apiKeys; track apiKey.value){
                    <tr>
                        <td>{{apiKey.scope}}</td>
                        <td>{{apiKey.creation.date | date:'yyyy-MM-dd'}}
                            @if(apiKey.creation.by){
                            <br/><small> by {{apiKey.creation.by}}</small>
                            }
                        </td>
                        <td style="text-overflow: ellipsis; overflow: hidden;white-space: nowrap;"
                            data-cy="api-key-value">{{apiKey.value}}</td>
                        <td>
                            <button class="btn btn-primary" (click)="copyKey(apiKey.value)" title="Copy to clipboard"><i class="fa-solid fa-copy"></i></button>
                        </td>
                        <td class="text-center">
                        </td>
                        <td class="text-center">
                            <button type="button"
                                    class="btn btn-default btn-action"
                                    (click)="renew(apiKey)"
                                    data-cy="api-key-renew"
                                    title="{{'api_keys.actions.renew' | translate}}"><i class="far fa-refresh"></i>
                            </button>
                        </td>
                        <td class="text-center">
                            <button type="button"
                                    class="btn btn-danger btn-action"
                                    data-cy="api-key-delete"
                                    (click)="delete(apiKey)"
                                    title="{{'api_keys.actions.delete' | translate}}"><i class="far fa-trash-alt"></i>
                            </button>
                        </td>
                        <td class="text-center">
                        </td>
                    </tr>
                    }
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    
    @if(deprecatedApiKeys?.length > 0){
    <div class="row bg-grey">
        <div class="col-md-8 mx-auto">
            <h4>{{'api_keys.deprecated.title' | translate}}</h4>
        </div>
    </div>
    
    <div class="row bg-grey filter-table">
        <div class="col-md-10 mx-auto">
            <div class="panel panel-default">
                <div class="panel-heading"><i class="far fa-key-skeleton"></i> {{'api_keys.deprecated.subtitle' | translate}}</div>
                <div class="panel-body">
                    <p>{{'api_keys.deprecated.desc' | translate}} <a href="https://apidocs.teammood.com" target="_blank">https://apidocs.teammood.com</a></p>
                </div>
                <table class="table table-hover">
                    <thead>
                    <tr>
                        <th>Team Name</th>
                        <th>Team Id</th>
                        <th>API Key</th>
                        <th>Authentication Header</th>
                        <th>{{'api_keys.deprecated.copyToClipboard' | translate}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    @for(apiKey of deprecatedApiKeys; track apiKey){
                    <tr>
                        <td>{{apiKey.teamName}}</td>
                        <td>{{apiKey.teamId}}</td>
                        <td>{{apiKey.value}}</td>
                        <td style="text-overflow: ellipsis; overflow: hidden;white-space: nowrap;">{{displayDeprecatedApiKey(apiKey)}}</td>
                        <td><button class="btn btn-primary" (click)="copyKey(displayDeprecatedApiKey(apiKey))" title="Copy Auth header to clipboard"><i class="fa-solid fa-copy"></i></button></td>
                    </tr>
                    }
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    }
</main>
